// @flow

import styled from 'styled-components';

export const SideDisplayTotal = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 1.5rem;
  font-weight: 500;
  font-family: ${props => props.theme.fontFamily.display};
  padding: 24px 16px;
  color: ${props => props.theme.colors.new_primary[700]};
`;

export const SideDisplayTotalTitle = styled.div``;

export const SideDisplayTotalValue = styled.div`
  font-size: 1.65rem;
`;
